<template>
    <section class="carrinho">
        <section class="main-carrinho pedido-realizado" :style="{ backgroundImage: 'url(' + $Url + bg_imagem + ')', height: '600px' }">

            <div class="container">
                <div class="row">
                    <div class="col-md-8 col-lg-8">
                        <div class="content">
                            <p v-html="ListaTextos[0].resumo1" style="color:#000000;font-size:40px;"></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>

</template>

<script>
    import { VMoney } from 'v-money'

    export default {
        components: {
        },
        directives: { money: VMoney },
        data() {
            return {
                bg_imagem: '',
                ListaTextos: [],
                Pedido: [],
                PedidoItem: [],
                PedidoItemAdicional: [],
                PedidoItemManual: [],
                Horarios: {},
                PedidoAgendamento: [],
                PedidoEndereco: [],
                Contato: {
                    NomeEmpresa: "",
                    Assunto: "",
                    Destinatario: "",
                    EmailResposta: "",
                    TextoEmail: "",
                    Anexo: "",
                    NomeAnexo: "",
                    TipoAnexo: "",
                },
                 Contato2: {
                    NomeEmpresa: "",
                    Assunto: "",
                    Destinatario: "",
                    EmailResposta: "",
                    TextoEmail: "",
                    Anexo: "",
                    NomeAnexo: "",
                    TipoAnexo: "",
                },
                Contato3: {
                    NomeEmpresa: "",
                    Assunto: "",
                    Destinatario: "",
                    EmailResposta: "",
                    TextoEmail: "",
                    Anexo: "",
                    NomeAnexo: "",
                    TipoAnexo: "",
                },
                Cupons: [],
            }
        },
        methods: {
            mensagem() {
                this.$redirect("/meusPedidosDetalhe/" + parseInt(this.Pedido.pedidoId, 10)); 
             },
            CarregaPedido() {
                let dadosArmazenados = localStorage.getItem(this.$UsuarioDados);
                dadosArmazenados = JSON.parse(dadosArmazenados);

                var dadosPedido = "<strong>Dados Cadastro</strong> <br><br>";
                dadosPedido += "Nome: " + dadosArmazenados.agenda[0].nome + "<br>";
                dadosPedido += "Telefone: " + dadosArmazenados.agenda[0].telefone + "<br>";
                dadosPedido += "E-mail: " + dadosArmazenados.agenda[0].email + "<br>";
                dadosPedido += "Endereço: " + dadosArmazenados.agenda[0].endereco + "<br>";
                dadosPedido += "Numero: " + dadosArmazenados.agenda[0].numero + "<br>";
                dadosPedido += "Complemento: " + dadosArmazenados.agenda[0].complemento + "<br>";
                dadosPedido += "CEP: " + dadosArmazenados.agenda[0].cep + "<br>";
                dadosPedido += "Cidade: " + dadosArmazenados.agenda[0].cidade + "<br>";
                dadosPedido += "Bairro: " + dadosArmazenados.agenda[0].bairro + "<br>";
                dadosPedido += "Estado: " + dadosArmazenados.agenda[0].estado ;
                
                dadosPedido += " <br><br> <strong>Dados Produtos</strong> <br><br>" ;
                dadosArmazenados.produtos.forEach((itemex) => {
                    dadosPedido += "Produto Id: " + itemex.produto.referencia + "<br>"
                    dadosPedido += "Nome: " + itemex.produto.nomeProduto + "<br>"
                    dadosPedido += "Quantidade: " + itemex.qtde + "<br><br><hr>"
                });
    
                this.Contato.NomeEmpresa = "Diproli Distribuidora"
                this.Contato.Assunto = "Solicitação de Orçamento Realizado no Site Diproli - Nome: " + dadosArmazenados.agenda[0].nome
                this.Contato.Destinatario = this.ListaTextos[0].referencia
                this.Contato.EmailResposta = dadosArmazenados.agenda[0].email
                this.Contato.TextoEmail = dadosPedido
                this.Contato.Anexo = ""
                this.Contato.NomeAnexo = ""
                this.Contato.TipoAnexo = "";

                this.EnviaEmail();

                this.Contato2.NomeEmpresa = "Diproli Distribuidora"
                this.Contato2.Assunto = "Solicitação de Orçamento Realizado no Site Diproli"
                this.Contato2.Destinatario = dadosArmazenados.agenda[0].email
                this.Contato2.EmailResposta = this.ListaTextos[0].referencia;
                this.Contato2.TextoEmail = dadosPedido + "<br><br> Seu pedido de orçamento foi realizado com sucesso! Em breve entraremos em contato!";
                this.Contato2.Anexo = "";
                this.Contato2.NomeAnexo = "";
                this.Contato2.TipoAnexo = "";

                this.EnviaEmail2();

                this.Contato3.NomeEmpresa = "Diproli Distribuidora"
                this.Contato3.Assunto = "Solicitação de Orçamento Realizado no Site Diproli"
                this.Contato3.Destinatario = "gestaoads@avancedigital.com.br"
                this.Contato3.EmailResposta = this.ListaTextos[0].referencia;
                this.Contato3.TextoEmail = dadosPedido + "<br><br> Seu pedido de orçamento foi realizado com sucesso! Em breve entraremos em contato!";
                this.Contato3.Anexo = "";
                this.Contato3.NomeAnexo = "";
                this.Contato3.TipoAnexo = "";

                this.EnviaEmail3();
                localStorage.removeItem(this.$UsuarioDados);
                                
            },
            EnviaEmail() {
                //var arquivos = document.getElementById("arquivo").files;
                //SE TIVER ANEXO:
                //if (arquivos != null && arquivos.length > 0) {
                //    var arq = "";
                //    var reader = new FileReader();
                //    var arquivoAnexo = arquivos[arquivos.length - 1];
                //    reader.readAsDataURL(arquivoAnexo);
                //    reader.onload = () => {
                //        arq = reader.result;
                //        this.Contato.Anexo = arq.toString().split(",")[1];
                //        this.Contato.NomeAnexo = arquivoAnexo.name;
                //        this.Contato.TipoAnexo = arquivoAnexo.type;
                //        this.$http
                //            .post(this.$apiUrl + "/contato/enviamail", this.Contato)
                //            .then(
                //                (response) => {
                //                    if (response.ok) alert("Enviado");
                //                },
                //                (error) => {
                //                    alert(error.bodyText);
                //                }
                //            );
                //    };
                //}
                //else {
                //SE NAO TIVER ANEXO:
                this.$http.post(this.$apiUrl + "/contato/enviamail", this.Contato)
                    .then(response => {
                        if (response.ok)
                            console.log("Enviado");
                    }, error => {
                        console.log("erro email 1")
                        console.log(error.bodyText)
                    });
                //}
            },
            EnviaEmail2() {
                //var arquivos = document.getElementById("arquivo").files;
                //SE TIVER ANEXO:
                //if (arquivos != null && arquivos.length > 0) {
                //    var arq = "";
                //    var reader = new FileReader();
                //    var arquivoAnexo = arquivos[arquivos.length - 1];
                //    reader.readAsDataURL(arquivoAnexo);
                //    reader.onload = () => {
                //        arq = reader.result;
                //        this.Contato.Anexo = arq.toString().split(",")[1];
                //        this.Contato.NomeAnexo = arquivoAnexo.name;
                //        this.Contato.TipoAnexo = arquivoAnexo.type;
                //        this.$http
                //            .post(this.$apiUrl + "/contato/enviamail", this.Contato)
                //            .then(
                //                (response) => {
                //                    if (response.ok) alert("Enviado");
                //                },
                //                (error) => {
                //                    alert(error.bodyText);
                //                }
                //            );
                //    };
                //}
                //else {
                //SE NAO TIVER ANEXO:
                this.$http.post(this.$apiUrl + "/contato/enviamail", this.Contato2)
                    .then(response => {
                        if (response.ok)
                            console.log("Enviado");
                    }, error => {
                        console.log("erro email 2")
                        console.log(error.bodyText)
                        
                    });
                //}
            },
            EnviaEmail3() {
                //var arquivos = document.getElementById("arquivo").files;
                //SE TIVER ANEXO:
                //if (arquivos != null && arquivos.length > 0) {
                //    var arq = "";
                //    var reader = new FileReader();
                //    var arquivoAnexo = arquivos[arquivos.length - 1];
                //    reader.readAsDataURL(arquivoAnexo);
                //    reader.onload = () => {
                //        arq = reader.result;
                //        this.Contato.Anexo = arq.toString().split(",")[1];
                //        this.Contato.NomeAnexo = arquivoAnexo.name;
                //        this.Contato.TipoAnexo = arquivoAnexo.type;
                //        this.$http
                //            .post(this.$apiUrl + "/contato/enviamail", this.Contato)
                //            .then(
                //                (response) => {
                //                    if (response.ok) alert("Enviado");
                //                },
                //                (error) => {
                //                    alert(error.bodyText);
                //                }
                //            );
                //    };
                //}
                //else {
                //SE NAO TIVER ANEXO:
                this.$http.post(this.$apiUrl + "/contato/enviamail", this.Contato3)
                    .then(response => {
                        if (response.ok)
                            console.log("Enviado");
                    }, error => {
                        console.log("erro email 3")
                        console.log(error.bodyText)
                        
                    });
                //}
            },
        },
        created() {
            let dadosArmazenados = localStorage.getItem(this.$UsuarioDados);
            dadosArmazenados = JSON.parse(dadosArmazenados);
            if (dadosArmazenados) {
                if (dadosArmazenados.agenda != '') {
                        this.$http
                            .get(this.$apiUrl + "/institucional/telas/textofinalizado")
                            .then((res2) => res2.json())
                            .then((tiu2) => {
                                this.ListaTextos = tiu2;
                                if (this.ListaTextos[0].institucionalImg != ''){
                                    this.bg_imagem = this.ListaTextos[0].institucionalImg[0].urlImagem;
                                }
                                console.log(this.ListaTextos)
                                this.CarregaPedido();
                            });
                 
                }
                else {
                    this.$redirect("/");
                }
            } else {
                this.$redirect("/");
            }
        }
    }

</script>

<style scoped>

    @import '/css_cart/carrinho.css';
    @import '/css_cart/nova_conta.css';
    @import '/css_cart/pedido_realizado.css';
</style>